import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, RouterOutlet } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { routes } from './app.routes';

import { WebUiModule } from 'web-ui';
import { WebCoreModule } from '@flashvpn-io/web-core';
import { environment } from '../environments/environment';

// 用于动态获取当前语言作为LOCALE_ID
export function localeIdFactory() {
  return localStorage.getItem('selectedLanguage') || 'zh-CN';
}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    WebCoreModule.forRoot({
      vapidKey: environment.vapidKey,
      production: environment.production,
      apiUrl: environment.apiUrl,
      web: environment.web,
      stripeKey: environment.stripeKey,
      tgBot: environment.tgBot,
      firebase: environment.firebase,
      frontDomain: environment.frontDomain,
    }),
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes),
    RouterOutlet,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    FormsModule,
    ReactiveFormsModule,
    WebUiModule,
  ],
  exports: [],
  providers: [
    // 动态提供LOCALE_ID，使其能够根据用户选择的语言更新
    { provide: LOCALE_ID, useFactory: localeIdFactory }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
